<template>
  <div v-if="showGroupVisaTile" class="flex flex-col">
    <router-link
      :to="{
        name: 'group-visa-information',
        params: { applicationId: applicationId },
      }"
      class="flex flex-row justify-start items-center mb-2"
    >
      <CheckMarkIcon :completed="completed" />
      <p
        class="text-sm font-semibold ml-4 ml-4"
        :class="completed ? 'text-gray-650' : 'text-cyan-700'"
      >
        Group Visa Information
      </p>
    </router-link>
  </div>
</template>

<script>
import CheckMarkIcon from "../SharedComponents/CheckMarkIcon.vue";
import postFormRules from "../../../mixins/postFormRules.js";
import { eventBus } from "@/eventBus.js";
import { mapState } from "vuex";

export default {
  name: "GroupVisaCard",
  components: { CheckMarkIcon },
  mixins: [postFormRules],
  data() {
    return {
      formURL: "groupvisainformation",
    };
  },
  computed: {
    ...mapState(["currentApplicationSubmissions"]),
    completed() {
      return Object.hasOwn(this.currentApplicationSubmissions, this.formURL);
    },
    applicationId() {
      return this.$route.params.applicationId;
    },
  },
  async mounted() {
    if (this.showGroupVisaTile) {
      eventBus.$emit("addPreDepartureForm", {
        label: "Group Visa Information",
        ruleName: "Group Visa Information",
        routeName: "group-visa-information",
        submitted: this.completed,
        travelSection: true,
      });
    }
  },
};
</script>
